var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 100,
    viewBox: "0 0 74 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    width: 74,
    height: 100,
    fill: "#EF574B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.5625 39.5H41.75V38.625C41.75 37.1776 40.5724 36 39.125 36H35.625C34.1776 36 33 37.1776 33 38.625V39.5H28.1875C26.9813 39.5 26 40.4813 26 41.6875V44.75C26 45.2332 26.3918 45.625 26.875 45.625H27.3532L28.1091 61.4999C28.1759 62.9018 29.3276 64 30.7311 64H44.0189C45.4224 64 46.5742 62.9018 46.6409 61.4999L47.3968 45.625H47.875C48.3582 45.625 48.75 45.2332 48.75 44.75V41.6875C48.75 40.4813 47.7687 39.5 46.5625 39.5ZM34.75 38.625C34.75 38.1425 35.1425 37.75 35.625 37.75H39.125C39.6075 37.75 40 38.1425 40 38.625V39.5H34.75V38.625ZM27.75 41.6875C27.75 41.4463 27.9463 41.25 28.1875 41.25H46.5625C46.8037 41.25 47 41.4463 47 41.6875V43.875C46.7303 43.875 28.8674 43.875 27.75 43.875V41.6875ZM44.8928 61.4166C44.8706 61.8839 44.4867 62.25 44.0189 62.25H30.7311C30.2633 62.25 29.8794 61.8839 29.8572 61.4166L29.1052 45.625H45.6448L44.8928 61.4166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M37.375 60.5C37.8582 60.5 38.25 60.1082 38.25 59.625V48.25C38.25 47.7668 37.8582 47.375 37.375 47.375C36.8918 47.375 36.5 47.7668 36.5 48.25V59.625C36.5 60.1082 36.8917 60.5 37.375 60.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.75 60.5C42.2332 60.5 42.625 60.1082 42.625 59.625V48.25C42.625 47.7668 42.2332 47.375 41.75 47.375C41.2668 47.375 40.875 47.7668 40.875 48.25V59.625C40.875 60.1082 41.2667 60.5 41.75 60.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33 60.5C33.4832 60.5 33.875 60.1082 33.875 59.625V48.25C33.875 47.7668 33.4832 47.375 33 47.375C32.5168 47.375 32.125 47.7668 32.125 48.25V59.625C32.125 60.1082 32.5167 60.5 33 60.5Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.bcba4e65dccddf466f5f6eea93b94b85.svg";
export { ForwardRef as ReactComponent };